import l, { css as i } from "styled-components";
import { Base as r } from "./atoms-v2777.js";
const t = l.div`
  ${r}

  display: flex;
  flex-direction: column;
  row-gap: 10px;
`, e = l.div`
  display: flex;
  row-gap: 10px;

  ${({ $layout: o }) => o === "vertical" ? i`
          flex-direction: column;
        ` : i`
          column-gap: 18px;
          flex-flow: row wrap;
        `}
`, n = l.div`
  ${({ theme: o }) => {
  var p;
  return (p = o == null ? void 0 : o.get("tokens.helper.productive")) == null ? void 0 : p.toJS();
}}
`;
export {
  t as CheckList,
  e as Inputs,
  n as Label
};
